import axios from './axios'
import config from '../config'

export default {
    listAllEtlJobTypes() {
        return axios({
            url: config.backendUrl + '/op/admin/etl-jobs/types',
            method: 'GET'
        })
    },
    listEtlJobs(params) {
        return axios({
            url: config.backendUrl + '/op/admin/etl-jobs',
            method: 'GET',
            params
        })
    },
    addEtlJob(data) {
        return axios({
            url: config.backendUrl + '/op/admin/etl-jobs',
            method: 'POST',
            data
        })
    },
    getUpdateEtlJobForm(id) {
        return axios({
            url: config.backendUrl + '/op/admin/etl-jobs/' + id + '/form',
            method: 'GET'
        })
    },
    updateEtlJob({id, data}) {
        return axios({
            url: config.backendUrl + '/op/admin/etl-jobs/' + id,
            method: 'PUT',
            data
        })
    },
    getEtlJob(id) {
        return axios({
            url: config.backendUrl + '/op/admin/etl-jobs/' + id,
            method: 'GET'
        })
    },
    deleteEtlJob(id) {
        return axios({
            url: config.backendUrl + '/op/admin/etl-jobs/' + id,
            method: 'DELETE'
        })
    },
    disableEtlJob(id) {
        return axios({
            url: config.backendUrl + '/op/admin/etl-jobs/' + id + '/disable',
            method: 'PUT'
        })
    },
    stopEtlJob(id) {
        return axios({
            url: config.backendUrl + '/op/admin/etl-jobs/' + id + '/stop',
            method: 'PUT'
        })
    },
    enableEtlJob(id) {
        return axios({
            url: config.backendUrl + '/op/admin/etl-jobs/' + id + '/enable',
            method: 'PUT'
        })
    },
    getEtlJobConfigTemplateByType(type) {
        return axios({
            url: config.backendUrl + '/op/admin/etl-jobs/job-config-template',
            method: 'GET',
            params: {type}
        })
    },
    getEtlJobDetails(id) {
        return axios({
            url: config.backendUrl + '/op/admin/etl-jobs/' + id + '/details',
            method: 'GET'
        })
    },
    getEtlJobLogs(id,from) {
        return axios({
            url: config.backendUrl + '/op/admin/etl-jobs/'+id+'/logs',
            method: 'GET',
            params: {from}
        })
    },
    checkCronExpression(cron) {
        return axios({
            url: config.backendUrl + '/op/admin/etl-jobs/check-cron-expression',
            method: 'PUT',
            params: {cron}
        })
    },
}
